import { render, staticRenderFns } from "./registrant-py.vue?vue&type=template&id=629ab954&scoped=true"
import script from "./registrant-py.vue?vue&type=script&lang=js"
export * from "./registrant-py.vue?vue&type=script&lang=js"
import style0 from "./registrant-py.vue?vue&type=style&index=0&id=629ab954&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629ab954",
  null
  
)

export default component.exports